import React from 'react';
import styles from './IppicaScommesseTypeSwitch.module.scss';
import classNames from 'classnames';

export type IppicaScommesseTypeSwitchProps = {
  selectedItem: number;
  onSelectedElement: (_index: number) => void;
  listButton: Array<string>;
};

export function IppicaScommesseTypeSwitch({
  selectedItem,
  onSelectedElement,
  listButton,
}: IppicaScommesseTypeSwitchProps) {
  return (
    <div className={styles.container}>
      {listButton.map((item: string, index: number) => {
        return (
          <button
            key={index}
            className={classNames(styles.button, {
              [styles.active]: selectedItem === index,
            })}
            onClick={() => {
              onSelectedElement(index);
            }}
          >
            {item}
          </button>
        );
      })}
    </div>
  );
}

export default IppicaScommesseTypeSwitch;
